// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.multi-select-container {
  width: 100%;
  /* ============================================================
     Trigger-level loader (shown while fetching options server-side)
     ============================================================ */
}
.multi-select-container .multi-select-trigger {
  --background: var(--ion-background-color);
  --border-color: var(--ion-color-light-shade);
  --border-radius: 12px;
  --color: var(--ion-text-color);
  --padding-start: 16px;
  --padding-end: 16px;
  height: 48px;
  text-align: left;
  justify-content: flex-start;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}
.multi-select-container .multi-select-trigger:hover {
  --border-color: var(--ion-color-primary-tint);
}
.multi-select-container .multi-select-trigger .trigger-text {
  flex: 1;
  text-align: left;
  font-weight: 500;
}
.multi-select-container .multi-select-trigger .selection-count {
  margin-left: 8px;
  --background: linear-gradient(135deg, var(--ion-color-primary), var(--ion-color-primary-shade));
  --color: white;
  font-weight: 600;
  font-size: 11px;
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
}
.multi-select-container .multi-select-trigger ion-icon[name=chevron-down] {
  margin-left: 8px;
  color: var(--ion-color-medium);
  transition: transform 0.3s ease;
}
.multi-select-container .multi-select-trigger.popover-open ion-icon[name=chevron-down] {
  transform: rotate(180deg);
}
.multi-select-container .multi-select-trigger.is-loading {
  cursor: progress;
}
.multi-select-container .multi-select-trigger.is-loading .trigger-text {
  font-style: italic;
  letter-spacing: 0.04em;
  opacity: 0.85;
  background: linear-gradient(90deg, #6b7280 0%, #a4d23d 50%, #6b7280 100%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: triggerTextShimmer 1.4s ease-in-out infinite;
}
.multi-select-container .trigger-loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-inline-end: 8px;
  flex-shrink: 0;
}
.multi-select-container .trigger-loader-ring {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #6ea01a;
  border-right-color: rgba(110, 160, 26, 0.45);
  box-shadow: 0 0 10px rgba(164, 210, 61, 0.45);
  animation: triggerLoaderSpin 0.85s linear infinite;
}
.multi-select-container .trigger-loader-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-inline-start: 6px;
  height: 18px;
}
.multi-select-container .trigger-loader-dots span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #6ea01a;
  box-shadow: 0 0 6px rgba(164, 210, 61, 0.65);
  animation: triggerLoaderDot 1s ease-in-out infinite;
}
.multi-select-container .trigger-loader-dots span:nth-child(2) {
  animation-delay: 0.15s;
}
.multi-select-container .trigger-loader-dots span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes triggerLoaderSpin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes triggerLoaderDot {
  0%, 100% {
    opacity: 0.25;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
  }
}
@keyframes triggerTextShimmer {
  0% {
    background-position: -120% 0;
  }
  100% {
    background-position: 120% 0;
  }
}
/* Dark mode adjustments per il trigger loader */
body.dark .multi-select-trigger.is-loading .trigger-text,
.dark .multi-select-trigger.is-loading .trigger-text {
  background: linear-gradient(90deg, #8a8e95 0%, #a4d23d 50%, #8a8e95 100%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* ===========================================================================
   Premium loader (shown when consumer is fetching options server-side)
   =========================================================================== */
.ms-search-loader {
  position: relative;
  margin: 0 12px 8px;
}
.ms-search-loader .ms-loader-track {
  display: block;
  height: 3px;
  border-radius: 999px;
  background: rgba(110, 160, 26, 0.12);
  overflow: hidden;
  box-shadow: 0 0 0 1px rgba(110, 160, 26, 0.18) inset;
  position: relative;
}
.ms-search-loader .ms-loader-bar {
  position: absolute;
  top: 0;
  left: -45%;
  height: 100%;
  width: 45%;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent 0%, rgba(164, 210, 61, 0.85) 25%, #6ea01a 50%, rgba(77, 182, 172, 0.85) 75%, transparent 100%);
  box-shadow: 0 0 12px rgba(164, 210, 61, 0.85);
  animation: msLoaderSlide 1.05s ease-in-out infinite;
}
.ms-search-loader .ms-loader-text {
  margin-top: 6px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--primary-green-darker, #6ea01a);
}
.ms-search-loader .ms-loader-text .ms-loader-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #a4d23d, #6ea01a);
  box-shadow: 0 0 8px rgba(164, 210, 61, 0.85);
  animation: msLoaderDot 1s ease-in-out infinite;
}
.ms-search-loader .ms-loader-text .ms-loader-typing {
  display: inline-flex;
  gap: 3px;
}
.ms-search-loader .ms-loader-text .ms-loader-typing span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--primary-green-darker, #6ea01a);
  animation: msTypingDot 1s ease-in-out infinite;
}
.ms-search-loader .ms-loader-text .ms-loader-typing span:nth-child(2) {
  animation-delay: 0.15s;
}
.ms-search-loader .ms-loader-text .ms-loader-typing span:nth-child(3) {
  animation-delay: 0.3s;
}

.options-container {
  position: relative;
}
.options-container.is-loading {
  min-height: 220px;
}

.ms-options-loader {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
}
.ms-options-loader .ms-skel {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 4px;
  border-radius: 10px;
  background: linear-gradient(90deg, rgba(164, 210, 61, 0.06) 0%, rgba(255, 255, 255, 0.55) 40%, rgba(77, 182, 172, 0.06) 100%);
  background-size: 200% 100%;
  animation: msSkelShimmer 1.4s ease-in-out infinite;
  border: 1px solid rgba(110, 160, 26, 0.1);
}
.ms-options-loader .ms-skel-check {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  background: linear-gradient(135deg, rgba(164, 210, 61, 0.25), rgba(77, 182, 172, 0.2));
  border: 1px solid rgba(110, 160, 26, 0.3);
  flex-shrink: 0;
}
.ms-options-loader .ms-skel-line {
  height: 10px;
  border-radius: 999px;
  flex: 1 1 auto;
  background: linear-gradient(90deg, rgba(110, 160, 26, 0.18) 0%, rgba(255, 255, 255, 0.65) 50%, rgba(110, 160, 26, 0.18) 100%);
  background-size: 200% 100%;
  animation: msSkelShimmer 1.4s ease-in-out infinite;
}
.ms-options-loader .ms-skel:nth-child(2) .ms-skel-line {
  width: 80%;
}
.ms-options-loader .ms-skel:nth-child(3) .ms-skel-line {
  width: 65%;
}
.ms-options-loader .ms-skel:nth-child(4) .ms-skel-line {
  width: 88%;
}
.ms-options-loader .ms-skel:nth-child(5) .ms-skel-line {
  width: 72%;
}
.ms-options-loader .ms-skel:nth-child(6) .ms-skel-line {
  width: 60%;
}

@keyframes msLoaderSlide {
  0% {
    left: -45%;
  }
  100% {
    left: 100%;
  }
}
@keyframes msLoaderDot {
  0%, 100% {
    opacity: 0.4;
    transform: scale(0.85);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
    box-shadow: 0 0 12px rgb(164, 210, 61);
  }
}
@keyframes msTypingDot {
  0%, 100% {
    opacity: 0.25;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
  }
}
@keyframes msSkelShimmer {
  0% {
    background-position: -120% 0;
  }
  100% {
    background-position: 120% 0;
  }
}
/* ===========================================================================
   ULTRA PREMIUM popover styling — clean, editorial, sober
   =========================================================================== */
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper,
::ng-deep .custom-multi-select-popover-wrapper {
  --width: 440px;
  --max-width: 92vw;
  --backdrop-opacity: 0.45;
  --background: transparent;
  --box-shadow: none;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper::part(backdrop),
::ng-deep .custom-multi-select-popover-wrapper::part(backdrop) {
  background: rgba(20, 24, 30, 0.55);
  backdrop-filter: blur(3px) saturate(0.95);
  -webkit-backdrop-filter: blur(3px) saturate(0.95);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper::part(content),
::ng-deep .custom-multi-select-popover-wrapper::part(content) {
  border-radius: 16px;
  overflow: hidden;
  background: transparent;
  box-shadow: 0 32px 80px rgba(15, 20, 30, 0.28), 0 10px 24px rgba(15, 20, 30, 0.12), 0 0 0 1px rgba(20, 40, 30, 0.06);
  animation: msPopIn 0.18s cubic-bezier(0.22, 0.85, 0.28, 1);
  will-change: transform, opacity;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper::part(backdrop),
::ng-deep .custom-multi-select-popover-wrapper::part(backdrop) {
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .multi-select-popover,
::ng-deep .custom-multi-select-popover-wrapper .multi-select-popover {
  position: relative;
  border-radius: 16px;
  background: #fdfdfa;
  border: 1px solid rgba(20, 40, 30, 0.06);
  isolation: isolate;
  overflow: hidden;
  padding: 0;
  /* Sottilissima linea oro sopra il bordo per profondità (nessun blob) */
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .multi-select-popover::before,
::ng-deep .custom-multi-select-popover-wrapper .multi-select-popover::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(110, 160, 26, 0.45) 30%, rgba(184, 134, 11, 0.55) 50%, rgba(110, 160, 26, 0.45) 70%, transparent 100%);
  pointer-events: none;
  z-index: 2;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-header,
::ng-deep .custom-multi-select-popover-wrapper .popover-header {
  position: relative;
  z-index: 1;
  padding: 22px 24px 18px;
  background: transparent;
  border-bottom: 1px solid rgba(20, 40, 30, 0.06);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-header .popover-header-row,
::ng-deep .custom-multi-select-popover-wrapper .popover-header .popover-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-header h4,
::ng-deep .custom-multi-select-popover-wrapper .popover-header h4 {
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 19px;
  font-weight: 600;
  letter-spacing: -0.005em;
  color: #14181f;
  /* Ornamento diamante sottile in oro/verde */
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-header h4::before,
::ng-deep .custom-multi-select-popover-wrapper .popover-header h4::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  background: linear-gradient(135deg, #b8860b 0%, #6ea01a 100%);
  transform: rotate(45deg);
  box-shadow: 0 0 0 1px rgba(184, 134, 11, 0.3), 0 0 8px rgba(184, 134, 11, 0.25);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-header .popover-count,
::ng-deep .custom-multi-select-popover-wrapper .popover-header .popover-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #f4f4ec;
  border: 1px solid rgba(20, 40, 30, 0.08);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-header p,
::ng-deep .custom-multi-select-popover-wrapper .popover-header p {
  margin: 10px 0 0 18px;
  font-size: 11.5px;
  letter-spacing: 0.04em;
  color: #8a8e95;
  font-weight: 400;
  line-height: 1.45;
  font-style: italic;
  font-family: Georgia, "Times New Roman", serif;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .search-container,
::ng-deep .custom-multi-select-popover-wrapper .search-container {
  position: relative;
  z-index: 1;
  padding: 16px 24px 8px;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .search-container ion-searchbar.compact-searchbar,
::ng-deep .custom-multi-select-popover-wrapper .search-container ion-searchbar.compact-searchbar {
  --background: #fbfbf6;
  --border-radius: 10px;
  --box-shadow: none;
  --color: #14181f;
  --placeholder-color: #b8b8b0;
  --placeholder-opacity: 1;
  --icon-color: #8a8e95;
  --clear-button-color: #b8b8b0;
  padding: 0;
  transition: all 0.18s ease;
  border: 1px solid rgba(20, 40, 30, 0.08);
  border-radius: 10px;
  min-height: 46px;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .search-container ion-searchbar.compact-searchbar:focus-within, :host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .search-container ion-searchbar.compact-searchbar.searchbar-has-focus,
::ng-deep .custom-multi-select-popover-wrapper .search-container ion-searchbar.compact-searchbar:focus-within,
::ng-deep .custom-multi-select-popover-wrapper .search-container ion-searchbar.compact-searchbar.searchbar-has-focus {
  --background: #ffffff;
  --icon-color: #6ea01a;
  border-color: #14181f;
  box-shadow: 0 0 0 4px rgba(20, 40, 30, 0.06);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container,
::ng-deep .custom-multi-select-popover-wrapper .options-container {
  position: relative;
  z-index: 1;
  max-height: 340px;
  overflow-y: auto;
  padding: 6px 14px 10px;
  margin: 0;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container::-webkit-scrollbar,
::ng-deep .custom-multi-select-popover-wrapper .options-container::-webkit-scrollbar {
  width: 5px;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container::-webkit-scrollbar-track,
::ng-deep .custom-multi-select-popover-wrapper .options-container::-webkit-scrollbar-track {
  background: transparent;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container::-webkit-scrollbar-thumb,
::ng-deep .custom-multi-select-popover-wrapper .options-container::-webkit-scrollbar-thumb {
  background: rgba(20, 40, 30, 0.18);
  border-radius: 999px;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container::-webkit-scrollbar-thumb:hover,
::ng-deep .custom-multi-select-popover-wrapper .options-container::-webkit-scrollbar-thumb:hover {
  background: rgba(20, 40, 30, 0.32);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item {
  --background: transparent;
  --background-hover: transparent;
  --background-focused: transparent;
  --background-activated: transparent;
  --inner-padding-top: 4px;
  --inner-padding-bottom: 4px;
  --padding-start: 16px;
  --padding-end: 12px;
  --min-height: 44px;
  --border-color: transparent;
  --color: #14181f;
  border-radius: 0;
  margin: 0;
  transition: padding-left 0.18s ease;
  cursor: pointer;
  position: relative;
  /* Hairline divider editoriale */
  /* Accent bar verticale a sinistra (hover/selected) */
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item::after,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item::after,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item::after,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(20, 40, 30, 0.06) 8%, rgba(20, 40, 30, 0.06) 92%, transparent 100%);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item:last-child::after,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item:last-child::after,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item:last-child::after,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item:last-child::after {
  display: none;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item::before,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item::before,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item::before,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 2px;
  border-radius: 0 2px 2px 0;
  background: linear-gradient(180deg, #b8860b 0%, #6ea01a 100%);
  transform: scaleY(0);
  transform-origin: center;
  transition: transform 0.22s cubic-bezier(0.2, 0.85, 0.3, 1);
  z-index: 1;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item:hover,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item:hover,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item:hover,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item:hover {
  --padding-start: 20px;
  --color: #000;
  background: linear-gradient(90deg, rgba(184, 134, 11, 0.04) 0%, transparent 50%);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item:hover::before,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item:hover::before,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item:hover::before,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item:hover::before {
  transform: scaleY(1);
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item ion-checkbox,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item ion-checkbox,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item ion-checkbox,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item ion-checkbox {
  --size: 16px;
  --checkbox-background: #ffffff;
  --checkbox-background-checked: #14181f;
  --border-color: rgba(20,40,30,0.30);
  --border-color-checked: #14181f;
  --border-radius: 3px;
  --border-width: 1.5px;
  --checkmark-color: #a4d23d;
  --checkmark-width: 2.5px;
  margin-inline-end: 16px;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item ion-label,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item ion-label,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item ion-label,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item ion-label {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.005em;
  color: #14181f;
  line-height: 1.45;
  font-feature-settings: "tnum" 1, "lnum" 1;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item {
  margin: 4px 0 6px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(20, 40, 30, 0.08);
  background: transparent !important;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item::after,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item::after,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item::after,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item::after {
  display: none;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item::before,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item::before,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item::before,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item::before {
  display: none;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item:hover,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item:hover,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item:hover,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item:hover {
  --padding-start: 16px;
  background: transparent;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item ion-label strong,
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item ion-label strong,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.option-item.select-all-item ion-label strong,
::ng-deep .custom-multi-select-popover-wrapper .options-container ion-item.select-all-item.select-all-item ion-label strong {
  letter-spacing: 0.22em;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 700;
  color: #8a8e95;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container .no-results,
::ng-deep .custom-multi-select-popover-wrapper .options-container .no-results {
  padding: 38px 16px;
  text-align: center;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container .no-results ion-icon,
::ng-deep .custom-multi-select-popover-wrapper .options-container .no-results ion-icon {
  font-size: 32px;
  color: rgba(20, 40, 30, 0.2);
  margin-bottom: 10px;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .options-container .no-results p,
::ng-deep .custom-multi-select-popover-wrapper .options-container .no-results p {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #9aa0a8;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-footer,
::ng-deep .custom-multi-select-popover-wrapper .popover-footer {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 24px 18px;
  border-top: 1px solid rgba(20, 40, 30, 0.06);
  background: linear-gradient(180deg, transparent, rgba(20, 40, 30, 0.015));
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-footer ion-button,
::ng-deep .custom-multi-select-popover-wrapper .popover-footer ion-button {
  --border-radius: 8px;
  letter-spacing: 0.14em;
  font-weight: 700;
  font-size: 10.5px;
  text-transform: uppercase;
  --padding-top: 12px;
  --padding-bottom: 12px;
  margin: 0;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-footer ion-button[fill=clear][color=medium],
::ng-deep .custom-multi-select-popover-wrapper .popover-footer ion-button[fill=clear][color=medium] {
  --color: #b8b8b0;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-footer ion-button[fill=clear][color=medium]:hover,
::ng-deep .custom-multi-select-popover-wrapper .popover-footer ion-button[fill=clear][color=medium]:hover {
  --color: #14181f;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-footer ion-button[fill=solid],
::ng-deep .custom-multi-select-popover-wrapper .popover-footer ion-button[fill=solid] {
  --background: #14181f !important;
  --background-hover: #000 !important;
  --background-activated: #000 !important;
  --background-focused: #000 !important;
  --color: #ffffff !important;
  --box-shadow:
    0 1px 0 rgba(255,255,255,0.10) inset,
    0 4px 14px rgba(20,24,30,0.30),
    0 1px 3px rgba(20,24,30,0.20) !important;
  --padding-start: 22px;
  --padding-end: 22px;
  letter-spacing: 0.16em;
  position: relative;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-footer ion-button[fill=solid] ion-icon,
::ng-deep .custom-multi-select-popover-wrapper .popover-footer ion-button[fill=solid] ion-icon {
  color: #a4d23d;
  font-size: 14px;
}
:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper .popover-footer .footer-actions,
::ng-deep .custom-multi-select-popover-wrapper .popover-footer .footer-actions {
  display: inline-flex;
  gap: 10px;
  align-items: center;
}

@keyframes msPopIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/multi-select/multi-select.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EAgDA;;mEAAA;AA3CF;AAHE;EACE,yCAAA;EACA,4CAAA;EACA,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;AAKJ;AAHI;EACE,6CAAA;AAKN;AAFI;EACE,OAAA;EACA,gBAAA;EACA,gBAAA;AAIN;AADI;EACE,gBAAA;EACA,+FAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AAGN;AAAI;EACE,gBAAA;EACA,8BAAA;EACA,+BAAA;AAEN;AACI;EACE,yBAAA;AACN;AAME;EACE,gBAAA;AAJJ;AAMI;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,yEAAA;EACA,0BAAA;EACA,6BAAA;EACQ,qBAAA;EACR,oCAAA;EACA,uDAAA;AAJN;AAQE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AANJ;AAQE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,4CAAA;EACA,6CAAA;EACA,kDAAA;AANJ;AAQE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,YAAA;AANJ;AAQI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,mDAAA;AANN;AAQI;EAAoB,sBAAA;AALxB;AAMI;EAAoB,qBAAA;AAHxB;;AAOA;EACE;IAAK,yBAAA;EAHL;AACF;AAIA;EACE;IAAW,aAAA;IAAe,wBAAA;EAA1B;EACA;IAAW,UAAA;IAAe,2BAAA;EAG1B;AACF;AAFA;EACE;IAAO,4BAAA;EAKP;EAJA;IAAO,2BAAA;EAOP;AACF;AALA,gDAAA;AACA;;EAEE,yEAAA;EACA,0BAAA;EACA,6BAAA;EACQ,qBAAA;EACR,oCAAA;AAOF;;AAHA;;gFAAA;AAGA;EACE,kBAAA;EACA,kBAAA;AAMF;AAJE;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,oCAAA;EACA,gBAAA;EACA,oDAAA;EACA,kBAAA;AAMJ;AAJE;EACE,kBAAA;EACA,MAAA;EAAQ,UAAA;EACR,YAAA;EACA,UAAA;EACA,oBAAA;EACA,6IAAA;EAMA,6CAAA;EACA,mDAAA;AAEJ;AAAE;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,2CAAA;AAEJ;AAAI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qDAAA;EACA,4CAAA;EACA,8CAAA;AAEN;AAAI;EACE,oBAAA;EACA,QAAA;AAEN;AADM;EACE,UAAA;EAAY,WAAA;EAAa,kBAAA;EACzB,gDAAA;EACA,8CAAA;AAKR;AAHM;EAAoB,sBAAA;AAM1B;AALM;EAAoB,qBAAA;AAQ1B;;AAHA;EACE,kBAAA;AAMF;AALE;EAAe,iBAAA;AAQjB;;AALA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAQF;AANE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6HAAA;EAIA,0BAAA;EACA,kDAAA;EACA,yCAAA;AAKJ;AAHE;EACE,WAAA;EAAa,YAAA;EACb,kBAAA;EACA,sFAAA;EACA,yCAAA;EACA,cAAA;AAMJ;AAJE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;EACA,6HAAA;EAIA,0BAAA;EACA,kDAAA;AAGJ;AADE;EAAsC,UAAA;AAIxC;AAHE;EAAsC,UAAA;AAMxC;AALE;EAAsC,UAAA;AAQxC;AAPE;EAAsC,UAAA;AAUxC;AATE;EAAsC,UAAA;AAYxC;;AATA;EACE;IAAO,UAAA;EAaP;EAZA;IAAO,UAAA;EAeP;AACF;AAdA;EACE;IAAW,YAAA;IAAc,sBAAA;EAkBzB;EAjBA;IAAW,UAAA;IAAc,qBAAA;IAAwB,sCAAA;EAsBjD;AACF;AArBA;EACE;IAAW,aAAA;IAAe,wBAAA;EAyB1B;EAxBA;IAAW,UAAA;IAAe,2BAAA;EA4B1B;AACF;AA3BA;EACE;IAAO,4BAAA;EA8BP;EA7BA;IAAO,2BAAA;EAgCP;AACF;AA9BA;;gFAAA;AAGA;;EAEE,cAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;AAgCF;AA9BE;;EACE,kCAAA;EACA,yCAAA;EACA,iDAAA;AAiCJ;AA/BE;;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oHACE;EAGF,0DAAA;EACA,+BAAA;AA+BJ;AA7BE;;EACE,0BAAA;EACA,kCAAA;AAgCJ;AA7BE;;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,uEAAA;AAgCJ;AA/BI;;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EAAQ,OAAA;EAAS,QAAA;EACjB,WAAA;EACA,8JAAA;EAMA,oBAAA;EACA,UAAA;AA+BN;AA3BE;;EACE,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;EACA,+CAAA;AA8BJ;AA5BI;;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA+BN;AA5BI;;EACE,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,8CAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EAEA,4CAAA;AA8BN;AA7BM;;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,6DAAA;EACA,wBAAA;EACA,+EAAA;AAgCR;AA5BI;;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,kCAAA;AA+BN;AA5BI;;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;AA+BN;AA3BE;;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;AA8BJ;AA5BI;;EACE,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,wBAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;EACA,0BAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;AA+BN;AA7BM;;;EACE,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,4CAAA;AAiCR;AA5BE;;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AA+BJ;AA7BI;;EAAuB,UAAA;AAiC3B;AAhCI;;EAA6B,uBAAA;AAoCjC;AAnCI;;EACE,kCAAA;EACA,oBAAA;AAsCN;AApCI;;EACE,kCAAA;AAuCN;AApCI;;;;EAEE,yBAAA;EACA,+BAAA;EACA,iCAAA;EACA,mCAAA;EACA,wBAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;EAEA,gCAAA;EAWA,qDAAA;AA6BN;AAvCM;;;;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EAAS,QAAA;EACT,WAAA;EACA,2HAAA;AA6CR;AA3CM;;;;EAAsB,aAAA;AAiD5B;AA9CM;;;;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EAAU,WAAA;EACV,UAAA;EACA,0BAAA;EACA,6DAAA;EACA,oBAAA;EACA,wBAAA;EACA,2DAAA;EACA,UAAA;AAoDR;AAjDM;;;;EACE,qBAAA;EACA,aAAA;EACA,gFAAA;AAsDR;AArDQ;;;;EAAY,oBAAA;AA2DpB;AAxDM;;;;EACE,YAAA;EACA,8BAAA;EACA,sCAAA;EACA,mCAAA;EACA,+BAAA;EACA,oBAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;AA6DR;AA3DM;;;;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,yCAAA;AAgER;AA7DM;;;;EACE,iBAAA;EACA,mBAAA;EACA,+CAAA;EACA,kCAAA;AAkER;AAjEQ;;;;EAAW,aAAA;AAuEnB;AAtEQ;;;;EAAY,aAAA;AA4EpB;AA3EQ;;;;EAAU,qBAAA;EAAuB,uBAAA;AAkFzC;AAjFQ;;;;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAsFV;AAjFI;;EACE,kBAAA;EACA,kBAAA;AAoFN;AAlFM;;EACE,eAAA;EACA,4BAAA;EACA,mBAAA;AAqFR;AAnFM;;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAsFR;AAjFE;;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,4CAAA;EACA,yEAAA;AAoFJ;AAlFI;;EACE,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AAqFN;AAnFI;;EACE,gBAAA;AAsFN;AArFM;;EAAU,gBAAA;AAyFhB;AAvFI;;EACE,gCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;EACA,2BAAA;EACA;;;4CAAA;EAIA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA0FN;AAxFM;;EACE,cAAA;EACA,eAAA;AA2FR;AAxFI;;EACE,oBAAA;EACA,SAAA;EACA,mBAAA;AA2FN;;AAtFA;EACE;IAAO,UAAA;IAAY,sCAAA;EA2FnB;EA1FA;IAAO,UAAA;IAAY,iCAAA;EA8FnB;AACF","sourcesContent":[".multi-select-container {\n  width: 100%;\n\n  .multi-select-trigger {\n    --background: var(--ion-background-color);\n    --border-color: var(--ion-color-light-shade);\n    --border-radius: 12px;\n    --color: var(--ion-text-color);\n    --padding-start: 16px;\n    --padding-end: 16px;\n    height: 48px;\n    text-align: left;\n    justify-content: flex-start;\n    position: relative;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n    transition: all 0.3s ease;\n\n    &:hover {\n      --border-color: var(--ion-color-primary-tint);\n    }\n\n    .trigger-text {\n      flex: 1;\n      text-align: left;\n      font-weight: 500;\n    }\n\n    .selection-count {\n      margin-left: 8px;\n      --background: linear-gradient(135deg, var(--ion-color-primary), var(--ion-color-primary-shade));\n      --color: white;\n      font-weight: 600;\n      font-size: 11px;\n      min-width: 20px;\n      height: 20px;\n      border-radius: 10px;\n    }\n\n    ion-icon[name=\"chevron-down\"] {\n      margin-left: 8px;\n      color: var(--ion-color-medium);\n      transition: transform 0.3s ease;\n    }\n\n    &.popover-open ion-icon[name=\"chevron-down\"] {\n      transform: rotate(180deg);\n    }\n  }\n\n  /* ============================================================\n     Trigger-level loader (shown while fetching options server-side)\n     ============================================================ */\n  .multi-select-trigger.is-loading {\n    cursor: progress;\n\n    .trigger-text {\n      font-style: italic;\n      letter-spacing: 0.04em;\n      opacity: 0.85;\n      background: linear-gradient(90deg, #6b7280 0%, #a4d23d 50%, #6b7280 100%);\n      background-size: 200% 100%;\n      -webkit-background-clip: text;\n              background-clip: text;\n      -webkit-text-fill-color: transparent;\n      animation: triggerTextShimmer 1.4s ease-in-out infinite;\n    }\n  }\n\n  .trigger-loader {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    margin-inline-end: 8px;\n    flex-shrink: 0;\n  }\n  .trigger-loader-ring {\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n    border: 2px solid transparent;\n    border-top-color: #6ea01a;\n    border-right-color: rgba(110,160,26,0.45);\n    box-shadow: 0 0 10px rgba(164,210,61,0.45);\n    animation: triggerLoaderSpin 0.85s linear infinite;\n  }\n  .trigger-loader-dots {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    margin-inline-start: 6px;\n    height: 18px;\n\n    span {\n      width: 4px;\n      height: 4px;\n      border-radius: 50%;\n      background: #6ea01a;\n      box-shadow: 0 0 6px rgba(164,210,61,0.65);\n      animation: triggerLoaderDot 1.0s ease-in-out infinite;\n    }\n    span:nth-child(2) { animation-delay: 0.15s; }\n    span:nth-child(3) { animation-delay: 0.30s; }\n  }\n}\n\n@keyframes triggerLoaderSpin {\n  to { transform: rotate(360deg); }\n}\n@keyframes triggerLoaderDot {\n  0%, 100% { opacity: 0.25; transform: translateY(0); }\n  50%      { opacity: 1;    transform: translateY(-2px); }\n}\n@keyframes triggerTextShimmer {\n  0%   { background-position: -120% 0; }\n  100% { background-position:  120% 0; }\n}\n\n/* Dark mode adjustments per il trigger loader */\nbody.dark .multi-select-trigger.is-loading .trigger-text,\n.dark      .multi-select-trigger.is-loading .trigger-text {\n  background: linear-gradient(90deg, #8a8e95 0%, #a4d23d 50%, #8a8e95 100%);\n  background-size: 200% 100%;\n  -webkit-background-clip: text;\n          background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n\n/* ===========================================================================\n   Premium loader (shown when consumer is fetching options server-side)\n   =========================================================================== */\n.ms-search-loader {\n  position: relative;\n  margin: 0 12px 8px;\n\n  .ms-loader-track {\n    display: block;\n    height: 3px;\n    border-radius: 999px;\n    background: rgba(110,160,26,0.12);\n    overflow: hidden;\n    box-shadow: 0 0 0 1px rgba(110,160,26,0.18) inset;\n    position: relative;\n  }\n  .ms-loader-bar {\n    position: absolute;\n    top: 0; left: -45%;\n    height: 100%;\n    width: 45%;\n    border-radius: 999px;\n    background: linear-gradient(90deg,\n      transparent 0%,\n      rgba(164,210,61,0.85) 25%,\n      #6ea01a 50%,\n      rgba(77,182,172,0.85) 75%,\n      transparent 100%);\n    box-shadow: 0 0 12px rgba(164,210,61,0.85);\n    animation: msLoaderSlide 1.05s ease-in-out infinite;\n  }\n  .ms-loader-text {\n    margin-top: 6px;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 10.5px;\n    font-weight: 800;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n    color: var(--primary-green-darker, #6ea01a);\n\n    .ms-loader-dot {\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background: linear-gradient(135deg, #a4d23d, #6ea01a);\n      box-shadow: 0 0 8px rgba(164,210,61,0.85);\n      animation: msLoaderDot 1.0s ease-in-out infinite;\n    }\n    .ms-loader-typing {\n      display: inline-flex;\n      gap: 3px;\n      span {\n        width: 4px; height: 4px; border-radius: 50%;\n        background: var(--primary-green-darker, #6ea01a);\n        animation: msTypingDot 1.0s ease-in-out infinite;\n      }\n      span:nth-child(2) { animation-delay: 0.15s; }\n      span:nth-child(3) { animation-delay: 0.30s; }\n    }\n  }\n}\n\n.options-container {\n  position: relative;\n  &.is-loading { min-height: 220px; }\n}\n\n.ms-options-loader {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 12px;\n\n  .ms-skel {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 4px;\n    border-radius: 10px;\n    background: linear-gradient(90deg,\n      rgba(164,210,61,0.06) 0%,\n      rgba(255,255,255,0.55) 40%,\n      rgba(77,182,172,0.06) 100%);\n    background-size: 200% 100%;\n    animation: msSkelShimmer 1.4s ease-in-out infinite;\n    border: 1px solid rgba(110,160,26,0.10);\n  }\n  .ms-skel-check {\n    width: 18px; height: 18px;\n    border-radius: 5px;\n    background: linear-gradient(135deg, rgba(164,210,61,0.25), rgba(77,182,172,0.20));\n    border: 1px solid rgba(110,160,26,0.30);\n    flex-shrink: 0;\n  }\n  .ms-skel-line {\n    height: 10px;\n    border-radius: 999px;\n    flex: 1 1 auto;\n    background: linear-gradient(90deg,\n      rgba(110,160,26,0.18) 0%,\n      rgba(255,255,255,0.65) 50%,\n      rgba(110,160,26,0.18) 100%);\n    background-size: 200% 100%;\n    animation: msSkelShimmer 1.4s ease-in-out infinite;\n  }\n  .ms-skel:nth-child(2) .ms-skel-line { width: 80%; }\n  .ms-skel:nth-child(3) .ms-skel-line { width: 65%; }\n  .ms-skel:nth-child(4) .ms-skel-line { width: 88%; }\n  .ms-skel:nth-child(5) .ms-skel-line { width: 72%; }\n  .ms-skel:nth-child(6) .ms-skel-line { width: 60%; }\n}\n\n@keyframes msLoaderSlide {\n  0%   { left: -45%; }\n  100% { left: 100%; }\n}\n@keyframes msLoaderDot {\n  0%, 100% { opacity: 0.4; transform: scale(0.85); }\n  50%      { opacity: 1;   transform: scale(1.20); box-shadow: 0 0 12px rgba(164,210,61,1); }\n}\n@keyframes msTypingDot {\n  0%, 100% { opacity: 0.25; transform: translateY(0); }\n  50%      { opacity: 1;    transform: translateY(-2px); }\n}\n@keyframes msSkelShimmer {\n  0%   { background-position: -120% 0; }\n  100% { background-position:  120% 0; }\n}\n\n/* ===========================================================================\n   ULTRA PREMIUM popover styling — clean, editorial, sober\n   =========================================================================== */\n:host ::ng-deep ion-popover.custom-multi-select-popover-wrapper,\n::ng-deep .custom-multi-select-popover-wrapper {\n  --width: 440px;\n  --max-width: 92vw;\n  --backdrop-opacity: 0.45;\n  --background: transparent;\n  --box-shadow: none;\n\n  &::part(backdrop) {\n    background: rgba(20,24,30,0.55);\n    backdrop-filter: blur(3px) saturate(0.95);\n    -webkit-backdrop-filter: blur(3px) saturate(0.95);\n  }\n  &::part(content) {\n    border-radius: 16px;\n    overflow: hidden;\n    background: transparent;\n    box-shadow:\n      0 32px 80px rgba(15,20,30,0.28),\n      0 10px 24px rgba(15,20,30,0.12),\n      0 0 0 1px rgba(20,40,30,0.06);\n    animation: msPopIn 0.18s cubic-bezier(.22,.85,.28,1.0);\n    will-change: transform, opacity;\n  }\n  &::part(backdrop) {\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px);\n  }\n\n  .multi-select-popover {\n    position: relative;\n    border-radius: 16px;\n    background: #fdfdfa;\n    border: 1px solid rgba(20,40,30,0.06);\n    isolation: isolate;\n    overflow: hidden;\n    padding: 0;\n    /* Sottilissima linea oro sopra il bordo per profondità (nessun blob) */\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0; left: 0; right: 0;\n      height: 1px;\n      background: linear-gradient(90deg,\n        transparent 0%,\n        rgba(110,160,26,0.45) 30%,\n        rgba(184,134,11,0.55) 50%,\n        rgba(110,160,26,0.45) 70%,\n        transparent 100%);\n      pointer-events: none;\n      z-index: 2;\n    }\n  }\n\n  .popover-header {\n    position: relative;\n    z-index: 1;\n    padding: 22px 24px 18px;\n    background: transparent;\n    border-bottom: 1px solid rgba(20,40,30,0.06);\n\n    .popover-header-row {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 14px;\n    }\n\n    h4 {\n      margin: 0;\n      display: inline-flex;\n      align-items: center;\n      gap: 12px;\n      font-family: Georgia, \"Times New Roman\", serif;\n      font-size: 19px;\n      font-weight: 600;\n      letter-spacing: -0.005em;\n      color: #14181f;\n\n      /* Ornamento diamante sottile in oro/verde */\n      &::before {\n        content: '';\n        display: inline-block;\n        width: 6px;\n        height: 6px;\n        background: linear-gradient(135deg, #b8860b 0%, #6ea01a 100%);\n        transform: rotate(45deg);\n        box-shadow: 0 0 0 1px rgba(184,134,11,0.30), 0 0 8px rgba(184,134,11,0.25);\n      }\n    }\n\n    .popover-count {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      min-width: 28px;\n      height: 22px;\n      padding: 0 8px;\n      border-radius: 999px;\n      background: #f4f4ec;\n      border: 1px solid rgba(20,40,30,0.08);\n      font-size: 10.5px;\n      font-weight: 700;\n      letter-spacing: 0.06em;\n      color: #6b7280;\n      font-variant-numeric: tabular-nums;\n    }\n\n    p {\n      margin: 10px 0 0 18px;\n      font-size: 11.5px;\n      letter-spacing: 0.04em;\n      color: #8a8e95;\n      font-weight: 400;\n      line-height: 1.45;\n      font-style: italic;\n      font-family: Georgia, \"Times New Roman\", serif;\n    }\n  }\n\n  .search-container {\n    position: relative;\n    z-index: 1;\n    padding: 16px 24px 8px;\n\n    ion-searchbar.compact-searchbar {\n      --background: #fbfbf6;\n      --border-radius: 10px;\n      --box-shadow: none;\n      --color: #14181f;\n      --placeholder-color: #b8b8b0;\n      --placeholder-opacity: 1;\n      --icon-color: #8a8e95;\n      --clear-button-color: #b8b8b0;\n      padding: 0;\n      transition: all 0.18s ease;\n      border: 1px solid rgba(20,40,30,0.08);\n      border-radius: 10px;\n      min-height: 46px;\n\n      &:focus-within, &.searchbar-has-focus {\n        --background: #ffffff;\n        --icon-color: #6ea01a;\n        border-color: #14181f;\n        box-shadow: 0 0 0 4px rgba(20,40,30,0.06);\n      }\n    }\n  }\n\n  .options-container {\n    position: relative;\n    z-index: 1;\n    max-height: 340px;\n    overflow-y: auto;\n    padding: 6px 14px 10px;\n    margin: 0;\n\n    &::-webkit-scrollbar { width: 5px; }\n    &::-webkit-scrollbar-track { background: transparent; }\n    &::-webkit-scrollbar-thumb {\n      background: rgba(20,40,30,0.18);\n      border-radius: 999px;\n    }\n    &::-webkit-scrollbar-thumb:hover {\n      background: rgba(20,40,30,0.32);\n    }\n\n    ion-item.option-item,\n    ion-item.select-all-item {\n      --background: transparent;\n      --background-hover: transparent;\n      --background-focused: transparent;\n      --background-activated: transparent;\n      --inner-padding-top: 4px;\n      --inner-padding-bottom: 4px;\n      --padding-start: 16px;\n      --padding-end: 12px;\n      --min-height: 44px;\n      --border-color: transparent;\n      --color: #14181f;\n      border-radius: 0;\n      margin: 0;\n      transition: padding-left 0.18s ease;\n      cursor: pointer;\n      position: relative;\n\n      /* Hairline divider editoriale */\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 0; right: 0;\n        height: 1px;\n        background: linear-gradient(90deg, transparent 0%, rgba(20,40,30,0.06) 8%, rgba(20,40,30,0.06) 92%, transparent 100%);\n      }\n      &:last-child::after { display: none; }\n\n      /* Accent bar verticale a sinistra (hover/selected) */\n      &::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        top: 8px; bottom: 8px;\n        width: 2px;\n        border-radius: 0 2px 2px 0;\n        background: linear-gradient(180deg, #b8860b 0%, #6ea01a 100%);\n        transform: scaleY(0);\n        transform-origin: center;\n        transition: transform 0.22s cubic-bezier(.2,.85,.3,1);\n        z-index: 1;\n      }\n\n      &:hover {\n        --padding-start: 20px;\n        --color: #000;\n        background: linear-gradient(90deg, rgba(184,134,11,0.04) 0%, transparent 50%);\n        &::before { transform: scaleY(1); }\n      }\n\n      ion-checkbox {\n        --size: 16px;\n        --checkbox-background: #ffffff;\n        --checkbox-background-checked: #14181f;\n        --border-color: rgba(20,40,30,0.30);\n        --border-color-checked: #14181f;\n        --border-radius: 3px;\n        --border-width: 1.5px;\n        --checkmark-color: #a4d23d;\n        --checkmark-width: 2.5px;\n        margin-inline-end: 16px;\n      }\n      ion-label {\n        font-size: 13px;\n        font-weight: 500;\n        letter-spacing: 0.005em;\n        color: #14181f;\n        line-height: 1.45;\n        font-feature-settings: \"tnum\" 1, \"lnum\" 1;\n      }\n\n      &.select-all-item {\n        margin: 4px 0 6px;\n        padding-bottom: 8px;\n        border-bottom: 1px solid rgba(20,40,30,0.08);\n        background: transparent !important;\n        &::after { display: none; }\n        &::before { display: none; }\n        &:hover { --padding-start: 16px; background: transparent; }\n        ion-label strong {\n          letter-spacing: 0.22em;\n          text-transform: uppercase;\n          font-size: 10px;\n          font-weight: 700;\n          color: #8a8e95;\n        }\n      }\n    }\n\n    .no-results {\n      padding: 38px 16px;\n      text-align: center;\n\n      ion-icon {\n        font-size: 32px;\n        color: rgba(20,40,30,0.20);\n        margin-bottom: 10px;\n      }\n      p {\n        margin: 0;\n        font-size: 11px;\n        font-weight: 600;\n        letter-spacing: 0.20em;\n        text-transform: uppercase;\n        color: #9aa0a8;\n      }\n    }\n  }\n\n  .popover-footer {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 14px 24px 18px;\n    border-top: 1px solid rgba(20,40,30,0.06);\n    background: linear-gradient(180deg, transparent, rgba(20,40,30,0.015));\n\n    ion-button {\n      --border-radius: 8px;\n      letter-spacing: 0.14em;\n      font-weight: 700;\n      font-size: 10.5px;\n      text-transform: uppercase;\n      --padding-top: 12px;\n      --padding-bottom: 12px;\n      margin: 0;\n    }\n    ion-button[fill=\"clear\"][color=\"medium\"] {\n      --color: #b8b8b0;\n      &:hover { --color: #14181f; }\n    }\n    ion-button[fill=\"solid\"] {\n      --background: #14181f !important;\n      --background-hover: #000 !important;\n      --background-activated: #000 !important;\n      --background-focused: #000 !important;\n      --color: #ffffff !important;\n      --box-shadow:\n        0 1px 0 rgba(255,255,255,0.10) inset,\n        0 4px 14px rgba(20,24,30,0.30),\n        0 1px 3px rgba(20,24,30,0.20) !important;\n      --padding-start: 22px;\n      --padding-end: 22px;\n      letter-spacing: 0.16em;\n      position: relative;\n\n      ion-icon {\n        color: #a4d23d;\n        font-size: 14px;\n      }\n    }\n    .footer-actions {\n      display: inline-flex;\n      gap: 10px;\n      align-items: center;\n    }\n  }\n}\n\n@keyframes msPopIn {\n  from { opacity: 0; transform: translateY(8px) scale(0.96); }\n  to   { opacity: 1; transform: translateY(0)   scale(1); }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
